import {
    mapState,
    mapActions
} from 'vuex'
import viewName from '../constant'
import verifyCode from '../../components/verifyCode/verifyCode.vue'
import {
    isInvalidPhone
} from '../../utils/REG'
import {
    Button,
    Cell,
    Field,
    CellGroup,
    Toast
} from 'vant'
import {
    getFirstPage,
    getLocalConfig
} from '@/utils/session'
import {
    wxConfig
} from '@/utils/wxsdk'

export default {
    name: viewName.bindingPhone,
    components: {
        Button,
        Cell,
        Field,
        CellGroup,
        verifyCode
    },
    data () {
        return {
            isOfficialAccounts: false,
            source: '',
            imgInfo: {
                setImgCodeVal: '',
                error: false
            },
            smsInfo: {
                setSmsCodeVal: '',
                getSmsCodeLoading: false, // true 显示按钮加载状态， false 不显示按钮加载状态
                getSmsCodeDisabled: true, // true 禁用按钮，false 可点击按钮
                getSmsCodeText: '获取验证码', // 获取验证码按钮文字
                error: false
            },
            phoneInfo: {
                phoneVal: '',
                error: false
            },
            bindingInfo: {
                bindingLoading: false, // true 显示按钮加载状态， false 不显示按钮加载状态
                bindingDisabled: true // true 禁用按钮，false 可点击按钮
            },
            totalTime: 60,
            onCountDown: false
        }
    },
    computed: {
        ...mapState({
            loginState: ({
                login
            }) => login,
            isWeixin: ({ appInfo }) => appInfo.isWeixin
        })
    },
    watch: {
        // 'imgInfo.setImgCodeVal' (val) {
        //     const phoneVal = this.phoneInfo.phoneVal
        //     const countDown = this.onCountDown
        //     this.imgInfo.error = false
        //     if (val.length === 4 && phoneVal.length === 11) {
        //         if (!countDown) {
        //             this.smsInfo.getSmsCodeDisabled = false
        //         } else {
        //             this.smsInfo.getSmsCodeDisabled = true
        //         }
        //     } else {
        //         this.smsInfo.getSmsCodeDisabled = true
        //     }
        // },
        'smsInfo.setSmsCodeVal' (val) {
            const phoneVal = this.phoneInfo.phoneVal
            if (val.length >= 4 && phoneVal.length === 11) {
                this.bindingInfo.bindingDisabled = false
            } else {
                this.bindingInfo.bindingDisabled = true
            }
        },
        'phoneInfo.phoneVal' (val) {
            const smsCodeVal = this.smsInfo.setSmsCodeVal
            // const imgCodeVal = this.imgInfo.setImgCodeVal
            const countDown = this.onCountDown
            this.phoneInfo.error = false
            if (val.length === 11) {
                if (!countDown) {
                    this.smsInfo.getSmsCodeDisabled = false
                } else {
                    this.smsInfo.getSmsCodeDisabled = true
                }
            } else {
                this.smsInfo.getSmsCodeDisabled = true
            }
            if (val.length === 11 && smsCodeVal.length >= 4) {
                if (!countDown) {
                    this.bindingInfo.bindingDisabled = false
                } else {
                    this.bindingInfo.bindingDisabled = true
                }
            } else {
                this.bindingInfo.bindingDisabled = true
            }
        }
    },
    created () {
        // source=officialAccounts(来源是公众号)
        // this.source = this.$route.query.source
        // this.isOfficialAccounts = this.source === 'officialAccounts'
        // if (this.isOfficialAccounts) {
        //     // 1. 通过code请求接口获取用户信息
        //     this.getWxUserInfo(this.$route.query.code || '').then(wxUserInfo => {
        //         // 进入成功页面
        //         this.$router.push({
        //             name: 'bindingResult',
        //             query: {
        //                 phone: wxUserInfo.phone_number,
        //                 boundType: 'bound'
        //             }
        //         })
        //     })
        // }
    },
    activated () { },
    mounted () {
        this.getGraphValidateCode()
        this.setTitle()
    },
    beforeDestroy () { },
    methods: {
        ...mapActions([
            'setAppClass',
            'getGraphValidateCode',
            'getSmsCode',
            'getSendSmsCount',
            'userBindingPhone',
            'getWxUserInfo'
        ]),
        setTitle () {
            this.setAppClass({
                isAppend: false,
                className: 'bgWhiteColor'
            })
            this.$emit('setHeader', {
                title: '绑定手机号码',
                showHeader: true,
                showLeft: true
            })
        },
        /**
         * callback 子组件调用父组件：发送验证码
         */
        onSendSmsCode (picCode) {
            this.imgInfo.setImgCodeVal = picCode
            /* 发送验证码 */
            this.sendSmsCode()
        },
        bindingFn () {
            const phoneVal = this.phoneInfo.phoneVal
            const smsCodeVal = this.smsInfo.setSmsCodeVal
            // const imgCodeVal = this.imgInfo.setImgCodeVal
            // const imgId = this.loginState.beasImgId
            if (isInvalidPhone(phoneVal)) {
                this.bindingInfo.bindingDisabled = true
                this.bindingInfo.bindingLoading = true
                const params = {
                    phone_number: phoneVal,
                    sms_code: smsCodeVal,
                    // img_code: imgCodeVal,
                    // id: imgCodeVal && imgId,

                }
                this.isWeixin && Object.assign(params, {code: getLocalConfig('code') || localStorage.getItem('code')})
                this.userBindingPhone(params)
                    .then((res) => {
                        this.bindingInfo.bindingDisabled = false
                        this.bindingInfo.bindingLoading = false
                        // this.$router.replace({
                        //     name: 'bindingResult'
                        // })
                        let last = getFirstPage()
                        if (this.$route.params.type === 'back') {
                            this.$router.go(-1)
                        } else {
                            if (this.$route.query.source === 'officialAccounts') {
                                this.$router.push({
                                    name: 'bindingResult',
                                    query: {
                                        phone: phoneVal,
                                        boundType: 'binding'
                                    }
                                })
                            } else {
                                if (last && last.fullPath) {
                                    this.$router.push({
                                        path: last.fullPath
                                    })
                                } else {
                                    // alert('--------------------')
                                    this.$router.push({
                                        path: '/'
                                    })
                                }
                            }
                        }
                    })
                    .catch(err => {
                        if (err.errcode === 128) { // code过期重新授权
                            location.href = wxConfig()
                        } else {
                            this.bindingInfo.bindingDisabled = true
                            this.bindingInfo.bindingLoading = false
                        }
                    })
            } else {
                this.bindingInfo.bindingDisabled = true
                this.bindingInfo.bindingLoading = false
                this.phoneInfo.error = true
                Toast({
                    message: '请输入正确的手机号码',
                    duration: 1500,
                    forbidClick: true,
                    closeOnClick: true
                })
            }
        },
        refreshImgFn () {
            this.getGraphValidateCode()
        },
        /* 获取验证码 */
        async getSmsCodeFn () {
            await this.getSendSmsCount({
                phone: this.phoneInfo.phoneVal,
                type: 'bind_wechat'
            })
            /* 判断大于3次弹验证码 */
            if (this.loginState.smsSendCount > 2) {
                this.$refs.verifyCode.show()
            } else {
                this.sendSmsCode()
            }
        },
        sendSmsCode () {
            const phoneVal = this.phoneInfo.phoneVal
            const imgCodeVal = this.imgInfo.setImgCodeVal
            if (isInvalidPhone(phoneVal)) {
                this.smsInfo.getSmsCodeLoading = true
                const params = {
                    phone: phoneVal,
                    type: 'bind_wechat', // type注册：register,找回密码：find_pass，修改密码：set_pass,修改手机：edit_phone，修改提现密码：set_cash，快捷登录：quick_login，绑定微信：bind_wechat
                    verify_code: imgCodeVal
                }
                this.getSmsCode(params)
                    .then(() => {
                        this.smsInfo.getSmsCodeLoading = false
                        this.countDown()
                        this.$toast('短信验证码已发送')
                        this.$refs.verifyCode.hide()
                    })
                    .catch(_ => {
                        this.smsInfo.getSmsCodeLoading = false
                        this.smsInfo.getSmsCodeDisabled = false
                        this.imgInfo.setImgCodeVal = ''
                        this.imgInfo.error = true
                        this.getGraphValidateCode()
                    })
            } else {
                this.phoneInfo.error = true
                Toast({
                    message: '请输入正确的手机号码',
                    duration: 1500,
                    forbidClick: true,
                    closeOnClick: true
                })
            }
        },
        // 倒计时
        countDown () {
            this.smsInfo.getSmsCodeDisabled = true
            this.onCountDown = true
            this.smsInfo.getSmsCodeText = this.totalTime + 's后重发'
            let clock = setInterval(() => {
                this.totalTime--
                this.smsInfo.getSmsCodeText = this.totalTime + 's后重发'
                if (this.totalTime < 0) {
                    clearInterval(clock)
                    this.smsInfo.getSmsCodeText = '获取验证码'
                    this.totalTime = 60
                    this.smsInfo.getSmsCodeDisabled = false
                    this.onCountDown = false
                }
            }, 1000)
        }
    }
}
